import { IUser } from "../../common/types";
import { AppAction, AppActions } from "./action";

export interface IAppState {
  user: IUser | undefined;
}

export const initialAppState: IAppState = {
  user: undefined,
};

export const appReducer = (state: IAppState, action: AppAction) => {
  switch (action.type) {
    case AppActions.SET_USER:
      return {
        user: action.user,
      };
    default:
      return {
        ...state,
      };
  }
};
